import { BaseModel } from "@models/base.model";

export class PatientPayment extends BaseModel {
  ERAId: number;
  PatientId: number;
  PaymentTypeId: number;
  PaymentMethodId: number;
  PaymentDate: string = '';
  PostDate: string = '';
  ReferenceId: string = '';
  Amount: number = 0;
  Notes: string = '';
  UnappliedAmount: number = 0;
  PatientBalance: string = '';
  UnappliedBalance: string = '';
  LastStatement: string = '';
  StatementSent: string = '';
}

export class Payment extends BaseModel {
  PatientId: number;
  ReferenceId: string = '';
  BatchId: number;
  PaymentDate: string = '';
  AdjustmentDate: string = '';
  PaymentType: string = '';
  PaymentMethod: string = '';
  Amount: number = 0;
  Notes: string = '';
  UnappliedAmount: number = 0;
  TotalRowsCount: any;
}

export class patientPaymentMaster {
  PaymentType: Array<any> = [];
  PaymentMethod: Array<any> = [];
  Patient: any;
}

export class PatientPaymentViewModel {
  Entity = new PatientPayment();
  Masters = new patientPaymentMaster();
}

export class PaymentViewModel {
  PatientId: number;
  ReferenceId: string = '';
  PaymentDate: string = '';
  Notes: string = '';
  Amount: number = 0;
  BatchId: number;
  AdjustmentDate: string = '';
  UnappliedAmount: number = 0;
  PaymentType: string = '';
  PaymentMethod: string = '';
  Payer: string = '';
}